<template>
  <div class="info-item">
    <span class="label">{{ label }}：</span>
    <el-tooltip :content="content" placement="top" :disabled="disabled">
      <p ref="infoItemContentRef" :class="[`ellipsis-${showLine}line`]">{{ content }}</p>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'InfoItem',
  props: {
    label: String,
    content: String,
    showLine: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      disabled: false
    }
  },
  mounted() {
    this.calcDisabled()
  },
  updated() {
    this.calcDisabled()
  },
  methods: {
    calcDisabled() {
      const ref = this.$refs.infoItemContentRef
      if (!ref) {
        this.$nextTick(this.calcDisabled)
      } else {
        // 滚动宽包含隐藏内容，该值大于可视区域代表有内容被隐藏，需要提示完整内容
        this.disabled = ref.scrollWidth <= ref.clientWidth
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.info-item {
  display: flex;
  width: 100%;

  .label {
    display: inline-block;
    text-align: right;
    white-space: nowrap;
  }

  .content {
    flex: 1;
  }
}
</style>
